/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

export const repoCloner = [
  {
    git_repo_branch_info: {
      'autire-ai': {
        git_repos: {
          source_repo: 'git@bitbucket.org:prirosystemsinc/autire-ai.git',
          destination_repo: 'git@bitbucket.org:prirosystemsinc/git-cloner-test-repo.git',
        },
        git_branch_pairs: [
          {
            source_branch: 'develop',
            destination_branch: 'develop',
          },
        ],
      },
    },
  },
  {
    git_repo_branch_info: {
      'autire-ai': {
        git_repos: {
          source_repo: 'git@bitbucket.org:prirosystemsinc/autire-ai.git',
          destination_repo: 'git@bitbucket.org:prirosystemsinc/git-cloner-test-repo.git',
        },
        git_branch_pairs: [
          {
            source_branch: 'master',
            destination_branch: 'master',
          },
        ],
      },
    },
  },
];

export const commandId = 'a4b2c79c-66ce-4197-a107-c1def3df65eb';
